import { render } from "./DashboardDealerOverview.vue?vue&type=template&id=1921ac44&scoped=true"
import script from "./DashboardDealerOverview.vue?vue&type=script&lang=js"
export * from "./DashboardDealerOverview.vue?vue&type=script&lang=js"

import "./DashboardDealerOverview.vue?vue&type=style&index=0&id=1921ac44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1921ac44"]])

export default __exports__